"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferNotificationSubscriptionPanel = exports.BellIcon = exports.MainContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const styled_components_1 = __importDefault(require("styled-components"));
const OfferNotificationSubscriptionPanel = ({ setIsModalOpen }) => {
    return ((0, jsx_runtime_1.jsxs)(elements_1.Panel, { className: "m-t-m m-b-m flex-col", children: [(0, jsx_runtime_1.jsx)(elements_1.Title, { level: 3, type: "secondary", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offers.offer_notification_subscription_panel.didnt_find_suitable_offer" }) }), (0, jsx_runtime_1.jsx)(exports.BellIcon, { type: "bell" }), (0, jsx_runtime_1.jsx)("div", { className: "text-center", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offers.offer_notification_subscription_panel.tell_us_which_offers" }) }), (0, jsx_runtime_1.jsx)("div", { className: "text-center", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { className: "m-t-m", onClick: () => {
                        setIsModalOpen(true);
                    }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offers.offer_notification_subscription_panel.subscribe" }) }) })] }));
};
exports.OfferNotificationSubscriptionPanel = OfferNotificationSubscriptionPanel;
exports.MainContent = (0, styled_components_1.default)(elements_1.Panel) ``;
exports.BellIcon = (0, styled_components_1.default)(elements_1.Icon) `
	svg {
		width: 3rem;
		height: 3rem;
		stroke: ${({ theme }) => theme.color.gray6};
		margin-bottom: 1rem;
	}
`;
